<script>
    import Turnstile from "./Turnstile.svelte";
    import UserIcon from "$lib/images/user.svg";
    import axiosInstance from "$lib/js/axios.js";
    import { getCookie } from "$lib/js/getCookie.js";
    import { secondsLeft, canResend, startConfirmationTimer, stopConfirmationTimer } from "/src/confirmationTimer";
    import { userEmail, selectStep } from "/src/store";
    import Spinner from "./Spinner.svelte";

    export let nextStep;

    let code = "";
    let error_message = "";
    let success_message = "";
    let isSubmitting = false;
    let token = "";

    async function onConfirm() {
        if (isSubmitting) return;
        error_message = "";
        success_message = "";

        if (!code || code.trim().length !== 6) {
            error_message = "Код повинен містити 6 символів.";
            return;
        }

        if (!token) {
            error_message = "Перевірка безпеки не пройдена. Спробуйте ще раз.";
            return;
        }

        isSubmitting = true;

        const utm_source = getCookie("utm_source");
        const utm_medium = getCookie("utm_medium");
        const utm_campaign = getCookie("utm_campaign");
        const utm_term = getCookie("utm_term");
        const utm_content = getCookie("utm_content");
        const gclid = getCookie("gclid");

        const formData = new FormData();
        formData.append("code", code.trim());
        formData.append("email", $userEmail);
        formData.append("cf_turnstile_token", token);
        formData.append("utm_source", utm_source || "");
        formData.append("utm_medium", utm_medium || "");
        formData.append("utm_campaign", utm_campaign || "");
        formData.append("utm_term", utm_term || "");
        formData.append("utm_content", utm_content || "");
        formData.append("gclid", gclid || "");

        try {
            const res = await axiosInstance.post("/verify-email/", formData);
            if (res.data.status === true) {
                success_message = "Email підтверджено!";
                if (typeof document !== "undefined" && document.body) {
                    window.dataLayer.push({ event: "registration_succes" });
                }
                stopConfirmationTimer();
                selectStep.set("");
                nextStep();
            }
        } catch (err) {
            error_message = err?.response?.data?.detail || "Помилка підтвердження.";
        } finally {
            isSubmitting = false;
        }
    }

    async function resendCode() {
        error_message = "";
        success_message = "";

        try {
            const formData = new FormData();
            formData.append("email", $userEmail);

            const res = await axiosInstance.post("/resend-code/", formData);
            success_message = res.data.message || "Код відправлено знову!";
            startConfirmationTimer();
        } catch (err) {
            error_message = err?.response?.data?.detail || "Не вдалося надіслати код.";
        }
    }

    startConfirmationTimer();
</script>

<form on:submit|preventDefault={onConfirm}>
    <div class="inputs">
        <label class="input">
            <div class="icon"><img src={UserIcon} alt="Code" /></div>
            <input type="text" name="code" bind:value={code} placeholder="Введіть код підтвердження" required />
        </label>

        {#if error_message}
            <span class="span-error">{error_message}</span>
        {/if}
        {#if success_message}
            <span class="span-success">{success_message}</span>
        {/if}
    </div>

    <div class="form-buttons">
        <div class="payment-button">
            <button class="btn btn-primary" type="submit" disabled={isSubmitting}>
                {isSubmitting ? "Перевірка..." : "ПІДТВЕРДИТИ"}
            </button>
        </div>
    </div>

    {#if $canResend}
        <button class="btn" type="button" on:click={resendCode}> Надіслати ще раз </button>
    {:else}
        <p>
            Можна надіслати ще раз через {Math.floor($secondsLeft / 60)}:{($secondsLeft % 60)
                .toString()
                .padStart(2, "0")}
        </p>
    {/if}

    <p style="margin-top: 20px;">
        <strong style="color: #e74e4e">Увага!</strong> Не оновлюйте сторінку — повернутися назад буде неможливо.
    </p>
    <p>
        Якщо ви не підтвердите email протягом <strong style="color: #e74e4e;">15 хвилин</strong>, ваш акаунт буде
        автоматично видалено.
    </p>

    <div style="margin-left: auto; margin-right: auto; margin-top: 20px;">
        <Turnstile on:token={e => (token = e.detail)} />
    </div>
</form>

<Spinner isSpinner={isSubmitting} />

<style lang="scss">
    @import "/src/lib/scss/main";

    .span-error {
        color: #e74e4e;

        &:empty {
            display: none;
        }
    }

    .span-success {
        color: #24c03a;

        &:empty {
            display: none;
        }
    }

    .alert-block {
        margin-top: 30px;
        padding: 15px;
        background: #fff3cd;
        color: #856404;
        border: 1px solid #ffeeba;
        border-radius: 6px;
        font-size: 0.95rem;
    }

    form {
        width: 580px;
        display: flex;
        flex-direction: column;
        gap: 20px;
        padding: 0 10px 0 10px;

        & > .inputs {
            display: flex;
            flex-direction: column;
            width: 100%;
            gap: 15px;

            & > .error {
                border: 0.5px solid #9f0b0b !important;
            }

            .dropdown-img {
                width: 24px;
                height: 24px;
            }

            .arrow-img {
                width: 12px;
                height: 17px;
                transition: transform 0.3s ease;

                &.rotate {
                    transform: rotate(-180deg);
                }
            }
        }

        .payment-button {
            width: 100%;
            height: 64px;

            & > button {
                font-size: 18px;
                line-height: 140%;
                text-transform: uppercase;
                // color: #232323;
                font-weight: 900;
                font-style: italic;
            }
        }

        .bonus-main {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            row-gap: 10px;
        }

        .bonus-wrapper {
            display: flex;
            align-items: center;

            .bonus {
                border-radius: 10px;
                width: 47px;
                height: 25px;
                display: flex;
                align-items: center;
                justify-content: center;
                font-weight: 900;
                font-style: italic;
                font-size: 9pt;
                color: #0f0f0f;
                background: #fed500;
                margin-right: 10px;
            }

            p {
                font-weight: normal;
                font-style: normal;
                font-size: 9pt;
                color: #fffbef;
            }
        }

        p {
            font-size: 11pt;
            line-height: 140%;
            font-weight: 400;
            color: rgba(255, 255, 255, 0.4);

            a {
                font-weight: 500;
                // text-decoration: underline;
                // text-decoration-skip-ink: none;
                color: #fffbef;
            }
        }
    }

    .form-buttons {
        display: flex;
        // flex-wrap: wrap;
        align-items: center;
        justify-content: space-between;
        gap: 20px;

        @media (max-width: 768px) {
            flex-direction: column;
            gap: 12px;
        }
    }

    @media (max-width: 768px) {
        form {
            width: 100%;
            padding: 0 20px;

            .payment-button {
                height: auto;

                & > button {
                    width: 100%;
                    padding: 14px 0;
                    font-size: 16px;
                }
            }

            .inputs {
                gap: 12px;
            }

            .checkbox {
                p {
                    font-size: 10pt;
                    line-height: 130%;
                    text-align: left;
                }
            }

            .span-error {
                font-size: 12px;
            }

            .input {
                input {
                    font-size: 14px;
                    padding: 12px 50px 12px 50px;
                }

                .eye {
                    font-size: 14px;
                    right: 10px;
                }

                .icon img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
    }
</style>
